import { render, staticRenderFns } from "./DarkLogin.vue?vue&type=template&id=0cf13b98&scoped=true"
import script from "./DarkLogin.vue?vue&type=script&lang=js"
export * from "./DarkLogin.vue?vue&type=script&lang=js"
import style0 from "./DarkLogin.vue?vue&type=style&index=0&id=0cf13b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf13b98",
  null
  
)

export default component.exports